<div class="container-fluid">
  <app-pagetitle title="Job Cards" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row d-flex justify-content-between align-items-center mb-3">
            <div class="col-auto">
              <button class="btn btn-success" (click)="openModal(content, '', 'Add')">
                <i class="mdi mdi-plus mr-2"></i> Add Jobs
              </button>
            </div>
            <div class="col-auto">
              <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTerm" style="min-width: 250px;" />
            </div>
          </div>

          <div class="table-responsive mt-3" *ngIf="programData && programData.length > 0">
            <table class="table table-striped table-bordered table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%">
              <thead class="thead-dark">
                <tr>
                  <th>Job Name</th>
                  <th>Job Description</th>
                  <th>Created By</th>
                  <th>Updated Time</th>
                  <th>Operation</th>
                  <th style="width: 120px">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of programData | filter: searchTerm | slice: pageSize | slice: 0: itemsPerPage; let i = index">
                  <td>{{ item.jobName }}</td>
                  <td>{{ item.description || item.jobDescription || '-' }}</td>
                  <td>{{ item.is_system_created ? 'System' : 'User' }}</td>
                 <td>{{ item._ts * 1000 | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                  <td class="text-center">
                    <i class="mdi mdi-eye" title="View Operations" style="cursor: pointer; font-size: 18px;"
                      (click)="openModalOperation(Operation, item)"></i>
                  </td>
                  <td class="text-center">
                    <a (click)="openModal(content, item, 'Edit')" class="mr-3 text-primary" title="Edit" style="cursor: pointer">
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a class="text-danger" title="Delete" style="cursor: pointer" (click)="openModalDelete(deletetemp, item)">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            
            <div class="row mt-3" *ngIf="programData?.length > itemsPerPage">
              <div class="col-md-6">
                <ngb-pagination class="pagination-rounded" 
                  [collectionSize]="programData?.length" 
                  [pageSize]="itemsPerPage" 
                  [(page)]="currentPage" 
                  [maxSize]="5" 
                  [rotate]="true"
                  [ellipses]="false" 
                  [boundaryLinks]="true" 
                  (pageChange)="onPageChange(currentPage)">
                </ngb-pagination>
              </div>
            </div>
          </div>

          <div class="card" *ngIf="!programData || programData.length === 0">
            <div class="card-body text-center">
              <span *ngIf="errmsg === ''"><strong>No Job Cards Found. Please Add Job Cards</strong></span>
              <span *ngIf="errmsg !== ''"><strong>{{ errmsg }}</strong></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content role="document" let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ action }} Jobs</h5>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body p-4">
    <div class="text-left">
      <form (ngSubmit)="saveData()" [formGroup]="validationform" autocomplete="off">

        <div class="border rounded p-3 mb-3" style="border-color: #b0b8c1 !important;">
          <p class="font-weight-bold mb-3" style="font-size: 13px; color: #495057; letter-spacing: 0.4px;">
            📋 Part Information
          </p>

          <div class="row">
            <div class="form-group col-md-6">
              <label for="jobName" class="required">Job Name</label>
              <input type="text" maxlength="64" class="form-control" id="jobName"
                placeholder="Enter Job Name" formControlName="jobName"
                [ngClass]="{ 'is-invalid': submitted && form.jobName.errors }" />
              <div *ngIf="submitted && form.jobName.errors" class="invalid-feedback">
                <span *ngIf="form.jobName.errors.required">Job Name is mandatory.</span>
              </div>
            </div>

            <div class="form-group col-md-6">
              <label for="jobDescription">Job Description</label>
              <input type="text" maxlength="128" class="form-control" id="jobDescription"
                placeholder="Enter Job Description" formControlName="jobDescription" />
            </div>
          </div>
        </div>

        <div class="border rounded p-3 mb-3" style="border-color: #b0b8c1 !important;">
          <p class="font-weight-bold mb-3" style="font-size: 13px; color: #495057; letter-spacing: 0.4px;">
            🔧 Process Configuration
          </p>

          <div formArrayName="operationData">
            <div
              class="border rounded p-3 mb-3"
              style="border-color: #ced4da !important; background-color: #fafafa;"
              *ngFor="let operation of validationform.get('operationData')['controls']; let i = index"
              [formGroupName]="i">

              <div class="row align-items-center mb-3">
                <div class="col">
                  <strong style="font-size: 14px; color: #495057;">Process {{ i + 1 }}</strong>
                </div>

                <div class="col-auto d-flex align-items-center">
                  <label class="mb-0 mr-2" style="font-size: 12px; white-space: nowrap;">Configure Cycle Time</label>
                  <input type="checkbox" formControlName="isCycleTime" [id]="'isCycleTime_' + i"
                    [disabled]="action === 'Edit'" style="width: 15px; height: 15px; cursor: pointer;" />
                </div>

                <div class="col-auto d-flex align-items-center" *ngIf="operation.get('isCycleTime').value">
                  <label class="mb-0 mr-2" style="font-size: 12px; white-space: nowrap;">Sequential Cycle Time</label>
                  <input type="checkbox" formControlName="isSequential" [id]="'isSequential_' + i"
                    [disabled]="action === 'Edit'" style="width: 15px; height: 15px; cursor: pointer;" />
                </div>

                <div class="col-auto" *ngIf="validationform.get('operationData')['controls'].length > 1">
                  <span style="cursor: pointer;" title="Remove Operation" (click)="removeOperation(i)">
                    <i class="fas fa-minus-circle text-danger" style="font-size: 18px;"></i>
                  </span>
                </div>
              </div>
              <ng-container *ngIf="operation.get('isCycleTime').value && !operation.get('isSequential').value">
                <div class="row align-items-start">

                  <div class="form-group col-12 col-sm-6 col-md-4 mb-3">
                    <label class="required">Process Name/Program Name</label>
                    <input type="text" class="form-control" placeholder="Enter Number" formControlName="operationName"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.operationName').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.operationName').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.duplicateName">Process Number must be unique.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                  <div class="form-group col-12 col-sm-6 col-md-4 mb-3">
                    <label>Process Type</label>
                    <select class="form-control" formControlName="processName">
                      <option value="">Select Process</option>
                      <option *ngFor="let process of processData" [value]="process.processName">{{ process.processName }}</option>
                    </select>
                  </div>

                  <div class="form-group col-12 col-sm-6 col-md-4 mb-3">
                    <label class="required">Running Time (sec)</label>
                    <input type="number" class="form-control" placeholder="Seconds" formControlName="runningTime"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.runningTime').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.runningTime').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.runningTime').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.runningTime').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.runningTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                  <div class="form-group col-12 col-sm-6 col-md-4 mb-3">
                    <label class="required">Loading Time (sec)</label>
                    <input type="number" class="form-control" placeholder="Seconds" formControlName="loadingTime"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.loadingTime').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.loadingTime').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div> 
                  </div>

                  <div class="form-group col-12 col-sm-6 col-md-4 mb-3">
                    <label class="required">Unloading Time (sec)</label>
                    <input type="number" class="form-control" placeholder="Seconds" formControlName="unloadingTime"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.unloadingTime').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.unloadingTime').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                  <div class="form-group col-12 col-sm-6 col-md-4 mb-3">
                    <label class="required">Setup Time (sec)</label>
                    <input type="number" class="form-control" placeholder="Seconds" formControlName="standardSetupTime"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.standardSetupTime').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.standardSetupTime').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                  <div class="form-group col-12 mb-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" [id]="'partsPerCycleRadio_' + i"
                        value="partsPerCycle" formControlName="countingType" />
                      <label class="form-check-label" [for]="'partsPerCycleRadio_' + i">Parts per Cycle</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" [id]="'unitsPerPartRadio_' + i"
                        value="unitsPerPart" formControlName="countingType" />
                      <label class="form-check-label" [for]="'unitsPerPartRadio_' + i">Units per Part</label>
                    </div>
                    <input type="number" class="form-control mt-2" [id]="'partsPerCycle_' + i"
                      [placeholder]="operation.get('countingType').value === 'partsPerCycle' ? 'Enter Parts per Cycle' : 'Enter Units per Part'"
                      formControlName="partsPerCycle"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.partsPerCycle').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.partsPerCycle').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.partsPerCycle').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.partsPerCycle').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.partsPerCycle').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                </div>
              </ng-container>
              <ng-container *ngIf="operation.get('isCycleTime').value && operation.get('isSequential').value">
                <div class="row align-items-start">
                  <div class="form-group col-12 col-sm-6 col-md-4 mb-3">
                                        <label class="required">Process Name/Program Name</label>

                    <input type="text" class="form-control" placeholder="Enter Number" formControlName="operationName"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.operationName').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.operationName').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.decimalNotAllowed">No decimals allowed.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.duplicateName">Process Number must be unique.</span>
                    </div>
                  </div>

                  <div class="form-group col-12 col-sm-6 col-md-4 mb-3">
                    <label>Process Type</label>
                    <select class="form-control" formControlName="processName">
                      <option value="">Select Process</option>
                      <option *ngFor="let process of processData" [value]="process.processName">{{ process.processName }}</option>
                    </select>
                  </div>

                  <div class="form-group col-12 col-sm-6 col-md-4 mb-3">
                    <label class="required">Loading Time (sec)</label>
                    <input type="number" class="form-control" placeholder="Seconds" formControlName="loadingTime"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.loadingTime').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.loadingTime').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.loadingTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                  <div class="form-group col-12 col-sm-6 col-md-4 mb-3">
                    <label class="required">Unloading Time (sec)</label>
                    <input type="number" class="form-control" placeholder="Seconds" formControlName="unloadingTime"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.unloadingTime').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.unloadingTime').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.unloadingTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                  <div class="form-group col-12 col-sm-6 col-md-4 mb-3">
                    <label class="required">Setup Time (sec)</label>
                    <input type="number" class="form-control" placeholder="Seconds" formControlName="standardSetupTime"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.standardSetupTime').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.standardSetupTime').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.standardSetupTime').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                  <div class="form-group col-12 col-sm-6 col-md-4 mb-3">
                    <label class="required">Total Runtime (sec)</label>
                    <input type="number" class="form-control" formControlName="runningTime" placeholder="Auto-calculated" readonly 
                      style="background-color: #e9ecef;" />
                  </div>

                  <div class="form-group col-12 mb-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" [id]="'partsPerCycleRadio_' + i"
                        value="partsPerCycle" formControlName="countingType" />
                      <label class="form-check-label" [for]="'partsPerCycleRadio_' + i">Parts per Cycle</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" [id]="'unitsPerPartRadio_' + i"
                        value="unitsPerPart" formControlName="countingType" />
                      <label class="form-check-label" [for]="'unitsPerPartRadio_' + i">Units per Part</label>
                    </div>
                    <input type="number" class="form-control mt-2" [id]="'partsPerCycle_' + i"
                      [placeholder]="operation.get('countingType').value === 'partsPerCycle' ? 'Enter Parts per Cycle' : 'Enter Units per Part'"
                      formControlName="partsPerCycle"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.partsPerCycle').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.partsPerCycle').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.partsPerCycle').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.partsPerCycle').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.partsPerCycle').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                </div>

                <div formArrayName="sequenceData" class="mt-3 border-top pt-3">
                  <div class="d-flex align-items-center mb-3">
                    <h6 class="mb-0 font-weight-bold">Sequences</h6>
                    <button type="button" class="btn btn-sm btn-success ml-2" (click)="addSequenceOperation(i)">
                      <i class="fas fa-plus-circle mr-1"></i> Add Sequence
                    </button>
                  </div>

                  <div class="row mb-2 align-items-end"
                    *ngFor="let seq of operation.get('sequenceData')['controls']; let j = index"
                    [formGroupName]="j">

                    <div class="form-group col-12 col-sm-5 mb-2">
                      <label class="required">Sequence Number</label>
                      <input type="text" class="form-control" formControlName="seqNumber" placeholder="Enter Sequence Number"
                        [ngClass]="{ 'is-invalid': submitted && operation.get('sequenceData')['controls'][j].get('seqNumber')?.errors }" />
                      <div *ngIf="submitted && operation.get('sequenceData')['controls'][j].get('seqNumber')?.errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                        <span *ngIf="operation.get('sequenceData')['controls'][j].get('seqNumber')?.errors?.required">Required.</span>
                      </div>
                    </div>

                    <div class="form-group col-12 col-sm-5 mb-2">
                      <label class="required">Running Time (sec)</label>
                      <input type="number" class="form-control" formControlName="runningTime" placeholder="Seconds"
                        (input)="calculateTotalRuntime(i)"
                        [ngClass]="{ 'is-invalid': submitted && operation.get('sequenceData')['controls'][j].get('runningTime')?.errors }" />
                      <div *ngIf="submitted && operation.get('sequenceData')['controls'][j].get('runningTime')?.errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                        <span *ngIf="operation.get('sequenceData')['controls'][j].get('runningTime')?.errors?.required">Required.</span>
                        <span *ngIf="operation.get('sequenceData')['controls'][j].get('runningTime')?.errors?.negativeValue">Cannot be negative.</span>
                        <span *ngIf="operation.get('sequenceData')['controls'][j].get('runningTime')?.errors?.decimalNotAllowed">No decimals allowed.</span>
                      </div>
                    </div>

                    <div class="col-12 col-sm-2 mb-2 text-center"
                      *ngIf="operation.get('sequenceData')['controls'].length > 1">
                      <span style="cursor: pointer;" (click)="removeSequence(i, j)" title="Remove Sequence">
                        <i class="fas fa-minus-circle text-danger"></i>
                      </span>
                    </div>

                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="!operation.get('isCycleTime').value">
                <div class="row">
                  <div class="col-12 col-md-6 mb-3">
                                       <label class="required">Process Name/Program Name</label>

                    <input type="text" class="form-control" placeholder="Enter Process" formControlName="operationName"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.operationName').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.operationName').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.decimalNotAllowed">No decimals allowed.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.operationName').errors?.duplicateName">Process Name/No must be unique.</span>
                    </div>
                  </div>

                  <div class="form-group col-12 col-md-6 mb-3">
                    <label>Process Type</label>
                    <select class="form-control" formControlName="processName">
                      <option value="">Select Process</option>
                      <option *ngFor="let process of processData" [value]="process.processName">{{ process.processName }}</option>
                    </select>
                  </div>

                  <div class="col-12 col-md-6 mb-3">
                    <label class="required">Parts/Panel Target</label>
                    <div class="input-group">
                      <input type="number" class="form-control" placeholder="Enter Target" formControlName="target"
                        [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.target').errors }" />
                      <select class="form-control" style="max-width: 100px;" formControlName="targetHours"
                        [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.targetHours').errors }">
                        <option value="">Hrs</option>
                        <option *ngFor="let h of hoursArray" [value]="h">{{ h }}</option>
                      </select>
                    </div>
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.target').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.target').errors?.required">Target is required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.target').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.target').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.targetHours').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.targetHours').errors?.required">Hour selection is required.</span>
                    </div>
                  </div>

                  <div class="col-12 col-md-6 mb-3">
                    <label>Per Part Cycle Time (sec)</label>
                    <input type="text" class="form-control" readonly [value]="getPerPartCycleTime(i)" 
                      placeholder="Auto calculated" style="background-color: #e9ecef;" />
                  </div>

                  <div class="form-group col-12 mb-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" [id]="'partsPerCycleRadio_' + i"
                        value="partsPerCycle" formControlName="countingType" />
                      <label class="form-check-label" [for]="'partsPerCycleRadio_' + i">Parts per Cycle</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" [id]="'unitsPerPartRadio_' + i"
                        value="unitsPerPart" formControlName="countingType" />
                      <label class="form-check-label" [for]="'unitsPerPartRadio_' + i">Units per Part</label>
                    </div>
                    <input type="number" class="form-control mt-2" [id]="'partsPerCycle_' + i"
                      [placeholder]="operation.get('countingType').value === 'partsPerCycle' ? 'Enter Parts per Cycle' : 'Enter Units per Part'"
                      formControlName="partsPerCycle"
                      [ngClass]="{ 'is-invalid': submitted && validationform.get('operationData.' + i + '.partsPerCycle').errors }" />
                    <div *ngIf="submitted && validationform.get('operationData.' + i + '.partsPerCycle').errors" class="text-danger" style="font-size: 11px; margin-top: 3px;">
                      <span *ngIf="validationform.get('operationData.' + i + '.partsPerCycle').errors?.required">Required.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.partsPerCycle').errors?.negativeValue">Cannot be negative.</span>
                      <span *ngIf="validationform.get('operationData.' + i + '.partsPerCycle').errors?.decimalNotAllowed">No decimals allowed.</span>
                    </div>
                  </div>

                </div>
              </ng-container>

              <div class="border rounded p-3 mt-3" style="border-color: #dee2e6 !important; background-color: #f8f9fa;">
                <p class="font-weight-bold mb-3" style="font-size: 12px; color: #6c757d; letter-spacing: 0.3px;">
                  💰 Cost Configuration
                </p>

                <div class="row">
                  <div class="form-group col-12 d-flex align-items-center mb-3">
                    <input type="checkbox" formControlName="operatorCost"
                      [id]="'operatorCost_' + i"
                      class="mr-2" style="width: 18px; height: 18px; cursor: pointer;" />
                    <label class="mb-0" [for]="'operatorCost_' + i" style="font-size: 13px; cursor: pointer;">Include Operator Cost</label>
                  </div>

                  <div class="form-group col-md-6 mb-3">
                    <label style="font-size: 12px;">Fixed Cost</label>
                    <ng-multiselect-dropdown
                      class="dim-border"
                      [placeholder]="'Select Fixed Cost'"
                      [settings]="settings"
                      [data]="fixedCostData"
                      formControlName="fixedCost"
                      style="color: #000;">
                    </ng-multiselect-dropdown>
                  </div>

                  <div class="form-group col-md-6 mb-3">
                    <label style="font-size: 12px;">Variable Cost</label>
                    <ng-multiselect-dropdown
                      class="dim-border"
                      [placeholder]="'Select Variable Cost'"
                      [settings]="settings"
                      [data]="variableCostData"
                      formControlName="variableCost"
                      style="color: #000;">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-3">
            <button type="button" class="btn btn-sm btn-success" (click)="addOperation()">
              <i class="fas fa-plus-circle mr-1"></i> Add Operation
            </button>
          </div>

        </div>

        <div class="text-right mt-4">
          <button type="submit" class="btn btn-success px-4">Save</button>
          <button type="button" class="btn btn-secondary ml-2 px-4" (click)="cancel()">Cancel</button>
        </div>

      </form>
    </div>
  </div>
</ng-template>


<ng-template #deletetemp role="document" let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Job Card</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <p class="mb-4">Are you sure you want to delete this job card? This action cannot be undone.</p>
    <div class="text-right">
      <button type="button" class="btn btn-danger px-4" (click)="delete(delprogramId)">Delete</button>
      <button type="button" class="btn btn-secondary ml-2 px-4" (click)="modal.dismiss()">Cancel</button>
    </div>
  </div>
</ng-template>


<ng-template #Operation role="document" let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Operation Details</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div *ngIf="operationTempData && operationTempData.length > 0">
      <div *ngFor="let op of operationTempData; let idx = index" class="border rounded p-3 mb-3">
        <h6 class="font-weight-bold mb-3">Process :{{ op.operationName }}</h6>
        
        <div class="table-responsive mb-3">
          <table class="table table-sm table-bordered">
            <thead class="thead-light">
              <tr>
                <th>Process Number</th>
                <th *ngIf="op.processName">Process Name</th>
                <th *ngIf="op.target != null && op.target !== ''">Target</th>
                <th *ngIf="op.targetHours != null && op.targetHours !== ''">Target Hours</th>
                <th *ngIf="op.runningTime != null && op.runningTime !== ''">Runtime (sec)</th>
                <th *ngIf="op.loadingTime != null && op.loadingTime !== ''">Loading (sec)</th>
                <th *ngIf="op.unloadingTime != null && op.unloadingTime !== ''">Unloading (sec)</th>
                <th *ngIf="op.standardSetupTime != null && op.standardSetupTime !== ''">Setup Time (sec)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ op.operationName }}</td>
                <td *ngIf="op.processName">{{ op.processName }}</td>
                <td *ngIf="op.target != null && op.target !== ''">{{ op.target }}</td>
                <td *ngIf="op.targetHours != null && op.targetHours !== ''">{{ op.targetHours }}</td>
                <td *ngIf="op.runningTime != null && op.runningTime !== ''">{{ op.runningTime }}</td>
                <td *ngIf="op.loadingTime != null && op.loadingTime !== ''">{{ op.loadingTime }}</td>
                <td *ngIf="op.unloadingTime != null && op.unloadingTime !== ''">{{ op.unloadingTime }}</td>
                <td *ngIf="op.standardSetupTime != null && op.standardSetupTime !== ''">{{ op.standardSetupTime }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- <div *ngIf="op.operatorCost || (op.fixedCost && op.fixedCost.length > 0) || (op.variableCost && op.variableCost.length > 0)" class="mb-3">
          <h6 class="font-weight-bold">Cost Configuration</h6>
          <ul class="list-unstyled mb-0">
            <li *ngIf="op.operatorCost"><strong>Operator Cost:</strong> Included</li>
            <li *ngIf="op.fixedCost && op.fixedCost.length > 0">
              <strong>Fixed Costs:</strong> 
              <span *ngFor="let fc of op.fixedCost; let last = last">
                {{ fc.item_text }}<span *ngIf="!last">, </span>
              </span>
            </li>
            <li *ngIf="op.variableCost && op.variableCost.length > 0">
              <strong>Variable Costs:</strong> 
              <span *ngFor="let vc of op.variableCost; let last = last">
                {{ vc.item_text }}<span *ngIf="!last">, </span>
              </span>
            </li>
          </ul>
        </div> -->

        <!-- <div *ngIf="op.sequenceData && op.sequenceData.length > 0">
          <h6 class="font-weight-bold mt-3 mb-2">Sequence Data</h6>
          <table class="table table-sm table-bordered">
            <thead class="thead-light">
              <tr>
                <th>Sequence Number</th>
                <th>Running Time (sec)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let seq of op.sequenceData">
                <td>{{ seq.seqNumber || seq.sequenceId }}</td>
                <td>{{ seq.runningTime }}</td>
              </tr>
            </tbody>
          </table>
        </div> -->
      </div>
    </div>
    <div *ngIf="!operationTempData || operationTempData.length === 0" class="text-center text-muted">
      <p>No operation data available.</p>
    </div>
  </div>
</ng-template>